
<template>
  <div>
    <van-nav-bar title="微信绑定" fixed placeholder />
    <van-notice-bar left-icon="volume-o" text="用户名密码与网页端一致" />

    <div class="mt-2">
      <van-form @submit="onSubmit">
        <van-cell-group inset>
          <van-field
            v-model="username"
            name="username"
            label="用户名"
            :placeholder="usernamePlaceholder"
            :rules="[{ required: true, message: '请填写用户名' }]"
          />
          <van-field
            v-model="password"
            type="password"
            name="password"
            label="密码"
            :placeholder="passwordPlaceholder"
            :rules="[{ required: true, message: '请填写密码' }]"
          />
        </van-cell-group>
        <div style="margin: 16px">
          <van-button round block color="#1baeae" native-type="submit"
            >绑定</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from "vue";
import { login, addUser, checkUserExists } from "@/service/user";
import md5 from "js-md5";
import Cookies from "js-cookie";
import { Toast } from "vant";
import { useRouter } from "vue-router";
export default {
  setup() {
    const encodeType = JSON.parse(Cookies.get("school")).encodeType;
    const dinepo = Cookies.get("dinepo");
    const router = useRouter();
    const state = reactive({
      username: "",
      password: "",
      usernamePlaceholder:JSON.parse(Cookies.get("school")).usernamePlaceholder || "用户名",
      passwordPlaceholder:JSON.parse(Cookies.get("school")).passwordPlaceholder || "密码"
    });

    // 提交登录或注册表单
    const onSubmit = async (values) => {
      let checkUser = await checkUserExists({
        school: JSON.parse(Cookies.get("school")).school,
        username: values.username
      })
      if (checkUser && checkUser.data.status) {
        Toast.fail("绑定失败，\n此学号已经被绑定");
        return false;
      }
      let { data:{list, _hash_}, msg } = await login({
        username: values.username,
        password: encodeType === 1 ? md5(values.password) : values.password,
        from: "mobile",
      });
      if (list || _hash_) {
        let { data: useradd } = await addUser({
          openid: dinepo,
          username: list.id,
          password: encodeType === 1 ? md5(values.password) : values.password,
          name: list.name,
          card: list.card,
          deptName: list.deptName,
          email: list.email,
          gender: list.gender,
          mobile: list.mobile,
          qq: list.qq,
          roleName: list.roleName,
          tel: list.tel,
          school: JSON.parse(Cookies.get("school")).school,
          schoolName: JSON.parse(Cookies.get("school")).schoolName,
        });
        if (useradd.status) {
          Toast.success("绑定成功");
          Cookies.set("user", JSON.stringify(_hash_));
          Cookies.set("userObj", JSON.stringify(list));
          router.replace("/index");
        } else {
          Toast.fail(useradd.result);
        }
      } else {
        Toast.fail(msg)
      }
    };

    return {
      ...toRefs(state),
      onSubmit,
    };
  },
};
</script>

<style lang="less">
.van-toast__text {
  width: 120px;
}
</style>
